import React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import classnames from "classnames";
import { FieldError } from "react-hook-form";

export interface FormOption {
  value: string;
  text: string;
}

export interface FormSelectProps {
  registerReturn: UseFormRegisterReturn;
  placeholder?: string;
  error: FieldError | undefined;
  disabled: boolean;
  options: FormOption[];
}

export const FormSelect: React.FC<FormSelectProps> = ({
  registerReturn,
  placeholder,
  error,
  disabled,
  options,
}) => {
  const defaultValue = "";
  return (
    <div
      className={classnames("Form__Element", "FormSelection", {
        ValidationFail: !!error,
      })}
    >
      <select
        className={classnames("FormTextbox__Input")}
        disabled={disabled}
        defaultValue={defaultValue}
        placeholder={placeholder}
        {...registerReturn}
      >
        {placeholder && (<option disabled value={defaultValue}>{placeholder}</option>)}
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.text}</option>
        ))}
      </select>
      {error && (
        <span className="Form__Element__ValidationError">{error.message}</span>
      )}
    </div>
  );
};
